import "./DraftsTimeline.scss";

import { useEffect, useState } from "react";
import { JobInfo } from "../../../../../components/job/Job";
import JobDraft from "../../../../../components/job/draft/JobDraft";
import { JobDraftApiRoutes } from "../../../../../shared/api-routes/job/job-draft-api.routes";
import http from "../../../../../shared/utils/http";

const DraftsTimeline: React.FC = () => {
	const [drafts, setDrafts] = useState<JobInfo[]>([]);

	useEffect(() => {
		http.get(JobDraftApiRoutes.GET_ALL_MY_JOB_DRAFTS).then((res) => {
			setDrafts(res);
		});
	}, []);

	const onDeleteJob = (job_id: string) => {
		setDrafts((prev) => prev.filter((item) => item.id !== job_id));
	};

	return (
		<div className="grand-container">
			<div className="job_timeline_container">
				<p className="jobs__caption">Drafts</p>
				<div className="board-container drafts-container">
					{drafts.length > 0 ? (
						drafts.map((draft: any, index: number) => (
							<JobDraft
								onDeleteJob={onDeleteJob}
								jobInfo={draft}
								key={index}
							/>
						))
					) : (
						<div className="empty-state">
							<p className="empty-state__message">
								You don't have any draft yet
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default DraftsTimeline;
